import { ErrorBox } from "@metriport/shared-internal";

export default function DomainErrorPage() {
  // TODO 2188 Link docs
  return (
    <ErrorBox>No Canvas Domain found within the Metriport Canvas plugin configuration.</ErrorBox>
  );
}
